module.exports = __webpack_public_path__ + "static/media/icon_loop.29aaa6c4.svg";